import moment, { Moment } from 'moment-timezone';

import ApiOrderPayment from 'types/api/OrderPayment';

import Currency from 'models/Currency';
import { Timezone } from 'models/Market';
import Model from 'models/Model';
import Order from 'models/Order';
import PaymentTransaction, { PaymentProviderData } from 'models/PaymentTransaction';

import { getFormattedDate } from 'utils/date';
import { changeFromCent, displayPrice } from 'utils/math';

export enum PaidStatuses {
    NotPaid = 'notPaid',
    Paid = 'paid',
    Refunded = 'refunded',
}

export default class OrderPayment implements Model {
    id: string;
    dueTo: Moment;
    dueToDisplay: string;
    currency: Currency;
    priceGross: number;
    priceGrossDisplay: string;
    order: Order;
    paidStatus: PaidStatuses;
    paymentTransaction: PaymentTransaction;
    paymentProvider?: PaymentProviderData;


    constructor(data: ApiOrderPayment) {
        this.id = data.id;
        this.dueTo = data.dueTo && moment.utc(data.dueTo).tz(Timezone);
        this.dueToDisplay = this.dueTo && getFormattedDate(this.dueTo);
        this.currency = data.currency && new Currency(data.currency);
        this.priceGross = changeFromCent(data.priceGross);
        this.priceGrossDisplay = displayPrice(this.priceGross, this.currency);
        this.order = data.order && new Order(data.order);
        this.paidStatus = data.paidStatus;
        this.paymentTransaction = data.paymentTransaction && new PaymentTransaction(data.paymentTransaction);
        this.paymentProvider = data?.paymentProvider;
    }
}
